<article>
  <header>
    <strong>Importações de Motivo de Contato</strong>
    <section>
      <app-primary-button
        *ngIf="hasSupervisorRole"
        label="Adicionar"
        icon="assets/icons/add.svg"
        [color]="ButtonColorEnum.common"
        (clickFunc)="navigateToNewForm()"
      ></app-primary-button>
    </section>
  </header>
  <main>
    <app-contact-reason-list-header></app-contact-reason-list-header>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton">
        <div class="skeleton-column">
          <div class="skeleton-item"></div>
        </div>
      </div>
    </ng-container>
    <app-contact-reason-list-item
      *ngFor="let form of contactReasonList"
      [data]="form"
    ></app-contact-reason-list-item>
    <app-paginator
      [page]="page"
      [totalPages]="totalPages"
      [elementsShowing]="contactReasonList.length"
      [totalElements]="totalItems"
      (selectPageFunc)="handleSelectPage($event)"
    ></app-paginator>
  </main>
</article>
